export default "__VITE_ASSET__BrX3ERSu__"